/**
* Spotlight CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Spotlight CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'spotlight-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const overlay = $( '.spotlight-cta__overlay' )[0];

      let radius = 0;
      let targetRadius = 0;

      let mouseX = 0; let mouseY = 0; // current (animated) position
      let targetX = 0; let targetY = 0; // actual mouse position

      const maxRadius = 100;

      // Animate the spotlight
      function animate() {
        // Ease the radius
        radius += ( targetRadius - radius ) * 0.1;

        // Ease the position
        mouseX += ( targetX - mouseX ) * 0.1;
        mouseY += ( targetY - mouseY ) * 0.1;

        const gradient = `radial-gradient(circle ${radius}px at ${mouseX}px ${mouseY}px, transparent ${radius}px, black ${radius}px)`;
        overlay.style.maskImage = gradient;
        overlay.style.webkitMaskImage = gradient;

        requestAnimationFrame( animate );
      }

      animate(); // Start the loop

      // Track actual mouse position
      $( '.spotlight-cta' ).on( 'mousemove', ( e ) => {
        const rect = $( '.spotlight-cta' )[0].getBoundingClientRect();
        targetX = e.clientX - rect.left;
        targetY = e.clientY - rect.top;
      } );

      // Grow/shrink on hover
      $( '.spotlight-cta' ).on( 'mouseenter', () => {
        targetRadius = maxRadius;
      } );

      $( '.spotlight-cta' ).on( 'mouseleave', () => {
        targetRadius = 0;
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'spotlight-cta', COMPONENT );
} )( app );
